import React, { useEffect, useState,useRef } from "react";

import LeftSidebar from "../layout/LeftSidebar"; 
import HeaderBar from "../layout/HeaderBar";
import TransitionPanel from "../panels/TransitionPanel";
import AnimationPanel from "../panels/AnimationPanel";
import HomePanel from "../panels/HomePanel";
import VideoPanel from "../panels/VideoPanel";
import AudioPanel from "../panels/AudioPanel";
import ImagePanel from "../panels/ImagePanel";
import SubtitlesPanel from "../panels/SubtitlesPanel";
import TextPanel from "../panels/TextPanel";
import KeyframePanel from "../panels/KeyframePanel";
import FilterPanel from "../panels/FilterPanel";
import ElementsPanel from "../panels/ElementsPanel";
import FramePlayer from "../components/FramePlayer.jsx";


const EditorPage = ({blogId,mode }) => {
  const [activeSection, setActiveSection] = useState("home"); 
  const [imageFiles, setImageFiles] = useState([]);
  const [images, setImages] = useState([]);
  const [clipTransitions, setClipTransitions] = useState([]);
  const [clipAnimations, setClipAnimations] = useState([]);
  const [clipAnimationTiming, setClipAnimationTiming] = useState([]);
  const [transition, setTransition] = useState("fade");
  const [transitionDuration, setTransitionDuration] = useState(1.0);
  const [animationDuration, setAnimationDuration] = useState([]);
  const [durations, setDurations] = useState([]); // seconds per slide
  const [selectedTransitionIndex, setSelectedTransitionIndex] = useState(null);
  const [selectedAnimationIndex, setSelectedAnimationIndex] = useState(null);
  const [audioTracks, setAudioTracks] = useState([]);
  const [editorState, setEditorState] = useState([]);
  const [isRendering, setIsRendering] = useState(false);
  const exportTransformsRef = useRef({});
  const editorCanvasSizeRef = useRef({
    width: 0,
    height: 0
    });
    const [filters, setFilters] = useState({});




//  
  const [keyframes, setKeyframes] = useState({});
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [seekTime, setSeekTime] = useState(null);


const normalizeTransformForExport = (t) => {
  const sx = 1080 / t.canvasWidth;
  const sy = 1920 / t.canvasHeight;

  return {
    scale: t.scale,        // ✅ DO NOT SCALE THIS
    x: t.offsetX * sx,     // ✅ scale position
    y: t.offsetY * sy
  };
};

function normalizeKeyframeForExport(kf, canvasWidth, canvasHeight) {
  const sx = 1080 / canvasWidth;
  const sy = 1920 / canvasHeight;

  return {
    t: kf.time,               // seconds (no change)
    scale: kf.scale * sx,     // 🔥 critical
    x: kf.ox * sx,
    y: kf.oy * sy
  };
}





  useEffect(() => {
    if (mode === "edit") {
     
      loadProject(blogId);
    } else {
      console.log("Starting NEW project for blog:", blogId);
    }
  }, [blogId, mode]);

  const updateClipTransition = (index, newType) => {
  const updated = [...clipTransitions];
  updated[index] = newType;
  setClipTransitions(updated);
};

const updateClipAnimation = (index, type) => {
  setClipAnimations((prev) => {
    const arr = [...prev];
    arr[index] = type;
    return arr;
  });
};


const handleExport = async () => {
  setIsRendering(true);  // 🔥 Start loading state
  const form = new FormData();
form.append("blog_id", blogId); // from React state
  // IMAGES (all are files)
  images.forEach(img => {
    form.append("images", img.file);
  });

  // AUDIO FILES
  audioTracks.forEach(a => {
    if (a.type === "file" && a.file instanceof File) {
      form.append("audioFiles", a.file);
    }
  });

  // NORMALIZE TRANSFORMS
  const slideTransforms = Object.entries(exportTransformsRef.current).map(
  ([index, t]) => ({
    index: Number(index),
    transform: normalizeTransformForExport(t)
  })
);

const { width, height } = editorCanvasSizeRef.current;

const exportKeyframes = {};



Object.entries(keyframes).forEach(([slideIndex, frames]) => {
  exportKeyframes[slideIndex] = frames.map(kf =>
    normalizeKeyframeForExport(
      kf,
      width,
      height
    )
  );
});



 
  // JSON DATA (add URLs here)
  form.append("json_data", JSON.stringify({
    durations,
    clipTransitions,
    transitionDuration,
    slideTransforms,
    filters,
    keyframes:exportKeyframes,
    audioUrls: audioTracks
      .filter(t => t.type === "url" || t.type === "library")
      .map(t => t.src)
  }));

  const res = await fetch("api/upload-slideshow", {
    method: "POST",
    body: form
  });

  const text = await res.text();
  console.log("RAW RESPONSE:", text);

  try {
    const data = JSON.parse(text);
    console.log("watchTaskStatus type:", typeof watchTaskStatus);

    console.log("Export started! Task ID:", data.task_id);
    

     // Poll watcher
  watchTaskStatus(data.task_id, data.output_file);
  } catch (e) {
    console.error("JSON parse failed:", e);
  }
};


const watchTaskStatus = (taskId, outputFileName) => {
  console.log("WATCHER STARTED:", taskId, outputFileName);

  const poll = setInterval(async () => {
    try {
      console.log("Polling task:", taskId);

      const res = await fetch(`api/task-status/${taskId}`);
      const data = await res.json();

      const status = data.status;
      console.log("👉 Task status:", status);

      // Pending states
      if (
        status === "PENDING" ||
        status === "QUEUED" ||
        status === "RECEIVED"
      ) {
        console.log("⏳ Task is waiting in queue…");
        return;
      }

      // Started
      if (status === "STARTED") {
        console.log("⚙️ Task started rendering…");
        return;
      }

      // SUCCESS → download file
      if (status === "SUCCESS") {
        clearInterval(poll);
        setIsRendering(false);   // 🔥 Rendering completed
        console.log("🎉 Video ready:", outputFileName);

        const videoUrl = `https://reels.criterionb.com/${outputFileName}`;
        downloadVideo(videoUrl, outputFileName);
        return;
      }

      // FAILURE
      if (status === "FAILURE") {
        clearInterval(poll);
        setIsRendering(false);
        console.error("❌ Video render failed:", data.result);
        return;
      }

      // Any unexpected state
      console.log("🤨 Unknown status:", status);

    } catch (err) {
      console.error("Polling error:", err);
      setIsRendering(false);
    }
  }, 2000);
};





const downloadVideo = async (url, filename) => {
  const res = await fetch(url);
  const blob = await res.blob();

  // Convert to File if needed
  const file = new File([blob], filename, { type: "video/mp4" });

  console.log("Downloaded file object:", file);

  // Auto-save to user
  const tempUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = tempUrl;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(tempUrl);
};


const saveVideo = async  () => {
  try {
   const form = new FormData();
   form.append("blog_id", blogId); // from React state

  // IMAGES (all are files)
  images.forEach(img => {
    form.append("images", img.file);
  });

  // AUDIO FILES
  audioTracks.forEach(a => {
    if (a.type === "file" && a.file instanceof File) {
      form.append("audioFiles", a.file);
    }
  });

  // NORMALIZE TRANSFORMS
  const slideTransforms = Object.entries(exportTransformsRef.current).map(
  ([index, t]) => ({
    index: Number(index),
    transform: normalizeTransformForExport(t)
    })
  );

  const { width, height } = editorCanvasSizeRef.current;

  const exportKeyframes = {};

  console.log( "keyframes before export normalization",keyframes);

  Object.entries(keyframes).forEach(([slideIndex, frames]) => {
    exportKeyframes[slideIndex] = frames.map(kf =>
      normalizeKeyframeForExport(
        kf,
        width,
        height
      )
    );
  });

  // JSON DATA (add URLs here)
  form.append("json_data", JSON.stringify({
    durations,
    clipTransitions,
    transitionDuration,
    slideTransforms,
    filters,
    keyframes:exportKeyframes,
    audioUrls: audioTracks
      .filter(t => t.type === "url" || t.type === "library")
      .map(t => t.src)
  }));

  const res = await fetch("api/upload-slideshow", {
    method: "POST",
    body: form
  });

  const text = await res.text();
  console.log("RAW RESPONSE:", text);
    // iframe message ost message.
      try {
      const data = JSON.parse(text);

      const outputFile = data.output_file;
        console.log("Sending post mesage with  Output file and blog Id:", outputFile, blogId);
      // 🚀 SEND message IMMEDIATELY to parent
      window.parent.postMessage({
        type: "EXPORT_COMPLETE",
        payload: {
          output_file: outputFile,
          blog_id: blogId    // from React state
        }
      }, "*");

      // Optional: close the iframe UI or show message
      

    } catch (err) {
      console.error("Failed to parse response:", err);
      
    }
  } catch (e) {
    console.error("JSON parse failed:", e);
  }

}

const handleSaveProject = async () => {
  // build JSON state
  const editorState = {
    images: images.map(img => ({
      filename: img.file.name,
      selected: img.selected
    })),
    durations,
    clipTransitions,
    transitionDuration,
    audio: audioTracks.map(a => ({
      filename: a.file.name,
      start: a.start,
      volume: a.volume
    }))
  };
  const blog_id = ""; // you can dynamic this later

  const form = new FormData();
  form.append("blog_id", blog_id); // you can dynamic this later
  form.append("json_data", JSON.stringify(editorState));

  // attach actual files
  images.forEach(img => form.append("images", img.file));
  audioTracks.forEach(a => form.append("audio_files", a.file));

  const res = await fetch("api/save-project", {
    method: "POST",
    body: form
  });

  const data = await res.json();
  console.log("Saved:", data);
};

const loadProject = async (blogId) => {
  const res = await fetch(`api/load-project?blog_id=${blogId}`);
  const data = await res.json();

  if (data.status === "not-found") {
    console.log("No project yet for this blog.");
    return;
  }

  // hydrate editor
  setEditorState(data.json_data);
  setDurations(data.json_data.durations);
  setClipTransitions(data.json_data.clipTransitions);

  // load images (as selected=true)
  const loadedImages = data.images.map(url => ({
    file: null,
    url,
    selected: true
  }));
  setImages(loadedImages);

  // load audio
  const loadedAudio = data.audio.map(url => ({
    file: null,
    url
  }));
  setAudioTracks(loadedAudio);

  console.log("Project Loaded!", data);
  // 🔥 SWITCH TO IMAGES PANEL AFTER LOADING PROJECT
  setActiveSection("image");
};



    // pick the panel component
  const renderPanel = () => {
    const props = { };
    switch (activeSection) {
      case "home":
      return (
        <HomePanel
          onCreateNew={() => setActiveSection("image")}
          onLoadProject={(blogId) => loadProject(blogId)}
        />
      );
      case "video":
        return <VideoPanel {...props} />;
      case "audio":
        return <AudioPanel
         audioTracks={audioTracks}
         setAudioTracks={setAudioTracks} />;
      case "image":
        return <ImagePanel
          images={images}
          onImagesChange={setImages}   // new prop
          onImagesSelected={setImageFiles}
          onTransitionChange={setTransition}
          transitionDuration={transitionDuration}
          onTransitionDurationChange={setTransitionDuration}
          filters={filters}
          onOpenFilter={(index) => {
            setCurrentSlideIndex(index);
            setActiveSection("filter");
          }}
        />;
      case "subtitles":
        return <SubtitlesPanel {...props} />;
      case "text":
        return <TextPanel {...props} />;
      case "elements":
        return <ElementsPanel {...props} />;
      case "transition":
      return (
        <TransitionPanel
          index={selectedTransitionIndex}
          images={images}
          clipTransitions={clipTransitions}
          onChangeTransition={updateClipTransition}
          transitionDuration={transitionDuration}
          onChangeDuration={setTransitionDuration}
          setActiveSection={setActiveSection}
        />
      );
      case "animation":
      return (
        <AnimationPanel
          index={selectedAnimationIndex}
          images={images}
          clipAnimations={clipAnimations}
          onChangeAnimation={updateClipAnimation}
          animationDuration={animationDuration}
          setAnimationDuration={setAnimationDuration}
          clipAnimationTiming={clipAnimationTiming}
          setClipAnimationTiming={setClipAnimationTiming}
          onChangeDuration={setAnimationDuration}
          setActiveSection={setActiveSection}
        />

      );
      case "keyframe":
      return (
      <KeyframePanel
        slideIndex={currentSlideIndex}
        keyframes={keyframes}
        onJump={(time) => setSeekTime(time)}

        onDelete={(index, time) => {
          setKeyframes(prev => {
            const filtered = (prev[index] || []).filter(
              k => Math.abs(k.time - time) > 0.001
            );
            return { ...prev, [index]: filtered };
          });
        }}

        onDeleteAll={(index) => {
          setKeyframes(prev => ({
            ...prev,
            [index]: []     // ← remove all keyframes for that slide
          }));
        }}
      />

      );
      case "filter":
      return (
        <FilterPanel
          slideIndex={currentSlideIndex}
          filters={filters}
          setFilters={setFilters}
          previewSrc={
          images[currentSlideIndex]?.url ||
          images[currentSlideIndex]?.file &&
          URL.createObjectURL(images[currentSlideIndex].file)
          }
        />
      );
      default:
        return <div className="text-sm text-gray-400 p-4">No panel</div>;
    }
  };

  return (
  <div className="
    main-editor flex flex-col min-h-screen
    bg-gray-200 text-gray-900
    dark:bg-gray-950 dark:text-gray-100
    transition-colors duration-200
  ">

    {/* HEADER SECTION */}
    <HeaderBar 
      onExport={handleExport}
      onSave={saveVideo}
      isRendering={isRendering}
    />

    {/* BODY SECTION */}
    <div className="flex flex-row gap-6 p-6 flex-1">
      
      {/* Left Sidebar + Panels */}
      <div className="flex flex-row gap-4">
        <LeftSidebar
          active={activeSection}
          onChange={setActiveSection}
        />
        <aside className="
          w-72 rounded-lg p-4
          bg-gray-100 dark:bg-gray-900
          border border-gray-200 dark:border-gray-800
          transition-colors
        ">
          {renderPanel()}
        </aside>
      </div>

      {/* FramePlayer + Timeline */}
      <div className="flex-1 flex flex-col gap-4 min-w-[800px]">
        <FramePlayer
          images={imageFiles}
          durations={durations}
          setDurations={setDurations}
          transition={transition}
          transitionDuration={transitionDuration}
          clipTransitions={clipTransitions}
          setClipTransitions={setClipTransitions}
          onSelectTransition={(index) => {
            setSelectedTransitionIndex(index);
            setActiveSection("transition");
          }}
          clipAnimations={clipAnimations}
          setClipAnimations={setClipAnimations}
          clipAnimationTiming={clipAnimationTiming}
          setClipAnimationTiming={setClipAnimationTiming}
          onSelectAnimation={(index) => {
            setSelectedAnimationIndex(index);   // ✅ FIX
            setActiveSection("animation");
          }}
          animationDuration={animationDuration}
          setAnimationDuration={setAnimationDuration}
          audioTracks={audioTracks}
          keyframes={keyframes}
          setKeyframes={setKeyframes}
          onChangeCurrentIndex={setCurrentSlideIndex}
          seekTime={seekTime}
          exportTransformsRef={exportTransformsRef}
          editorCanvasSizeRef={editorCanvasSizeRef}
          filters={filters}
        />
        
      </div>
    </div>

  </div>
);

};

export default EditorPage;
